import React, { useState } from "react";

import { ContactProfileMoversAndShakersFragmentParameter, FunctionalGroup } from "@/app/pages/contactDirectory/interface";
import HooversModal from "@/app/pages/contactProfile/HooversModal";
import Paper from "@/app/pages/contactProfile/Paper";
import ProfileCard from "@/components/cards/ProfileCard";
import { createContactProfileUrl } from "@/app/pages/contactProfile/ContactProfileColleagues";

import "@/app/pages/contactProfile/styles/ContactProfileMoversAndShakersStyles.scss";

type GroupCardProps = FunctionalGroup;

const GroupCard = (props: GroupCardProps) => {
	const { count, name: propsName } = props;

	const [showModal, setShowModal] = useState(false);

	const onClickModalButton = (type: "close" | "open") => setShowModal(type === "open");

	return (
		<div className="group_card">
			<div className="group_text">
				<button
					className="ContactProfileMoversAndShakersFragmentComponentNameLink fuctional-groupname-contact suppress-ms-ext-icon link-with-underline"
					onClick={() => onClickModalButton("open")}
					title={propsName}
					type="button"
				>
					<p style={{wordBreak: "break-word"}}>
					{propsName}
					</p>
				</button>

				<span className="counts-text">
					{" "}

					(
					{count}
					)
				</span>
			</div>

			<HooversModal
				onClickModalButton={onClickModalButton}
				showModal={showModal} />
		</div>
	);
};

type ContactProfileMoversAndShakersFragmentComponentProps = ContactProfileMoversAndShakersFragmentParameter;

const ContactProfileMoversAndShakers = ({ contactMoversShakersData }: ContactProfileMoversAndShakersFragmentComponentProps): JSX.Element => {
	const {
		executiveContacts,
		functionalGroups,
		organizationName,
		success
	} = contactMoversShakersData;

	const [showModal, setShowModal] = useState(false);

	const setShowModalToTrue = () => setShowModal(true);
	const onClickModalButton = (type: "close" | "open") => setShowModal(type === "open");

	if (success) {
		const executiveContactsNotUndefined = executiveContacts!;
		const functionalGroupsNotUndefined = functionalGroups!;

		const executive =
			executiveContactsNotUndefined.length > 0
				?
				<div>
					<div className="row">
						<div className="col-xs-12 sub-heading">
							Executive Contacts
						</div>
					</div>

					<div className="row contact-card-style">
						{
							executiveContactsNotUndefined.map((ba, nu) => {
								const profileCardProps = {
									...ba,
									url: createContactProfileUrl(ba.url),
									onClickModalButton
								}

								return (
								<div
									className="col-md-3 inner-card-style"
									key={nu}>
									<ProfileCard {...profileCardProps} />
								</div>
								)}
								)
						}
					</div>

					<div className="row float-end">
						<div className="col-xs-12 hidden-xs hidden-sm text-right">
							<a
								className="suppress-ms-ext-icon anchor"
								onClick={setShowModalToTrue}
							>
								View All Executive Contacts
								{" "}

								<span className="right-arrow" />

								{" "}
							</a>
						</div>

						{
							executiveContactsNotUndefined.length > 1
								?
								<div className="col-xs-12 hidden-md hidden-lg">
									<div className="swipe-text">
										Swipe to view more
									</div>
								</div>
								: <></>
						}

						<div className="col-xs-12 hidden-md hidden-lg">
							<a
								className="view-all-btn suppress-ms-ext-icon"
								onClick={setShowModalToTrue}
							>
								View All Executive Contacts
							</a>
						</div>
					</div>
				</div>
				: <></>;

		const functionalGroup =
			functionalGroupsNotUndefined.length > 0
				?
				<div className="func-grp-wrap">
					<div className="row">
						<div className="col-xs-12 sub-heading">
							Other Contacts at

							{" "}

							{organizationName}
						</div>
					</div>

					<div className="flex-container">
						{
							functionalGroupsNotUndefined.slice(0, 8).map((fu, nu) =>
								<div key={nu}>
									<GroupCard {...fu} />
								</div>)
						}
					</div>

					<div className="row float-end">
						<div className="col-xs-12 hidden-xs hidden-sm text-right">
							<a
								className="suppress-ms-ext-icon anchor"
								onClick={setShowModalToTrue}
							>
								View All Functional Groups
								{" "}

								<span className="right-arrow" />

								{" "}
							</a>
						</div>

						{
							functionalGroupsNotUndefined.length > 1
								?
								<div className="col-xs-12 hidden-md hidden-lg">
									<div className="swipe-text">
										Swipe to view more
									</div>
								</div>
								: <></>
						}

						<div className="col-xs-12 hidden-md hidden-lg">
							<a
								className="view-all-btn suppress-ms-ext-icon"
								onClick={setShowModalToTrue}
							>
								View All Functional Groups
							</a>
						</div>
					</div>
				</div>
				: <></>;

		return (
			<Paper
				title={`Movers and Shakers at ${organizationName}`}
				onClickModalButton={onClickModalButton}
				blockName="moversAndShakers"
				blockId="movers-block"
				showModal={showModal}
			>
				<div className="row">
					<div className="col-md-7 col-xs-12 grey-text-padding-tb">
						See important contacts and find additional contacts through functional groups
					</div>

					<div className="col-md-5 hidden-xs hidden-sm access-link">
						<a
							className="suppress-ms-ext-icon anchor"
							onClick={setShowModalToTrue}
						>
							Access more contacts like these with D&B Hoovers
							{" "}

							<span className="right-arrow" />
						</a>
					</div>
				</div>

				{executive}

				{functionalGroup}

				<div className="hidden-md hidden-lg text-center">
					<a
						className="suppress-ms-ext-icon"
						onClick={setShowModalToTrue}
					>
						Access more contacts like these with D&B Hoovers
						{" "}

						<span className="right-arrow" />
					</a>
				</div>
			</Paper>
		);
	} else {
		return <></>;
	}
	
};

export default ContactProfileMoversAndShakers;
